import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import PageHeader from '@/components/PageHeader';
import InvitationAcceptPanel from '@/components/InvitationAcceptPanel';

export default function InvitationAcceptPage() {
  const { token } = useParams<{ token: string }>();

  if (!token?.trim()) {
    return <Navigate to="/account" replace />;
  }

  return (
    <div>
      <PageHeader title="Organization invitation" subtitle="Join your team workspace" />
      <div className="card section">
        <InvitationAcceptPanel token={token.trim()} />
      </div>
    </div>
  );
}
